<template>
  <v-container
    class="text-xs-center"
    fluid
    fill-height
  >
    <v-layout
      align-center
      justify-center
      fill-height
    >
      <v-flex
        class="form elevation-9 white"
        xs12
      >
        <v-layout
          class="header primary elevation-1"
          row
          wrap
          justify-center
          align-center
        >
          <div class="d-flex align-center">
            <img
              src="@/assets/max_logo_white.png"
              alt="Vizmo"
              height="72"
            >
            <span class="display-2 white--text mt-2">
              &nbsp;Admin
            </span>
          </div>
        </v-layout>
        <transition
          :enter-active-class="transitionEnterClass"
          :leave-active-class="transitionLeaveClass"
          mode="out-in"
          name="fade"
        >
          <router-view :key="$route.path" />
        </transition>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import pageTransitionMixin from '@/mixins/page-transition-mixin';

export default {
  name: 'Login',
  mixins: [pageTransitionMixin],
  data() {
    return {};
  },
  beforeRouteUpdate(to, from, next) {
    this.updatePageTransition(to, from);
    next();
  }
};
</script>

<style scoped>
.form {
  height: 480px;
  max-width: 450px;
  border-radius: 6px;
  overflow: hidden;
  position: relative;
}

.header {
  height: 120px;
  border-radius: 6px 6px 0 0;
}
</style>
